import { Link, LinkComponentProps } from '@tanstack/react-router'
import * as React from 'react'

/**
 * Can be used with the `as` prop to create a custom link component.
 *
 * @example
 * ```tsx
 * <RouterLink to="/company/analytics">Link</RouterLink>
 * <Button as={RouterLink} to="/company/analytics">Link</Button>
 * ```
 */
export const RouterLink = React.forwardRef(
  (props: LinkComponentProps, ref: React.Ref<HTMLAnchorElement>) => {
    return (
      <Link ref={ref} activeProps={{ 'aria-selected': 'true' }} {...props} />
    )
  },
)
